module.exports = __webpack_public_path__ + "2bf177ab6c68dd5e4055c8878cec9e6c.pdf";